// extracted by mini-css-extract-plugin
module.exports = {"md":"CatalogBonusPayBar_md_2rGQw","ios":"CatalogBonusPayBar_ios_1aL0C","button":"CatalogBonusPayBar_button_1KagK"};